export default __webpack_public_path__ + "static/media/WallNotification_Bethlehem-Picture.2c456873.png";